import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  userName:false,
	  nowVibe:'pc',
	  yhShow:sessionStorage.getItem('yhdj')?sessionStorage.getItem('yhdj')=='true'?true:false:false||false
  },
  mutations: {
	setUserName(state, name) {
		state.userName = name
	},
	setVibe(state, name){
		state.nowVibe = name
	},
	yhShowSet(state, name){
		state.yhShow = name
		sessionStorage.setItem('yhdj',state.yhShow)
	},
  },
  actions: {
  },
  modules: {
  }
})
